export const FontNormal = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontTitle = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontMono = "inconsolata, monospace";
export const FontWeightLight = 300;
export const FontWeightDefault = 400;
export const FontWeightMedium = 500;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontMicroSize = "8px";
export const FontMicroLineHeight = "12px";
export const FontLeftRailSize = "10px";
export const FontLeftRailLineHeight = "10px";
export const FontXsSize = "10px";
export const FontXsLineHeight = "16px";
export const FontSSize = "12px";
export const FontSLineHeight = "16px";
export const FontMSize = "14px";
export const FontMLineHeight = "20px";
export const FontLinkSize = "14px";
export const FontLinkLineHeight = "20px";
export const FontLSize = "16px";
export const FontLLineHeight = "24px";
export const FontHeader4Size = "20px";
export const FontHeader4LineHeight = "24px";
export const FontHeader3Size = "24px";
export const FontHeader3LineHeight = "32px";
export const FontHeader2Size = "32px";
export const FontHeader2LineHeight = "40px";
export const FontHeader1Size = "36px";
export const FontHeader1LineHeight = "44px";
export const FontHeroSize = "60px";
export const FontHeroLineHeight = "72px";
export const FontBrandH4Family = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontBrandH4Size = "20pt";
export const FontBrandH4LineHeight = "24px";
export const FontBrandH4Weight = 600;
export const FontBrandH4LetterSpacing = "-0.528px";
export const FontBrandLFamily = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontBrandLSize = "16pt";
export const FontBrandLLineHeight = "24px";
export const FontBrandLWeight = 600;
export const FontMonoMFamily = "inconsolata, monospace";
export const FontMonoMSize = "14pt";
export const FontMonoMLineHeight = "20px";
export const FontMonoSFamily = "inconsolata, monospace";
export const FontMonoSSize = "12pt";
export const FontMonoSLineHeight = "16px";
export const FontMonoXsFamily = "inconsolata, monospace";
export const FontMonoXsSize = "10pt";
export const FontMonoXsLineHeight = "16px";
